<template>
  <BasicLayout :left='left' :middle='middle' :right='right'>
    <template v-slot:left_view>
      <AllNeTree :trackType='1' neType='[mc_cms]'></AllNeTree>
    </template>
    <template v-slot:right_view>
      <ExportImpList></ExportImpList>
    </template>
  </BasicLayout>
</template>
<script>
import BasicLayout from '../../layouts/BasicLayout';
import AllNeTree from '../../components/system/ConfigInEx/AllNeTree';
import ExportImpList from '../../components/system/ConfigInEx/ExportImpList';

export default {
  name: 'SignalTrackPage',
  components: {
    BasicLayout,
    AllNeTree,
    ExportImpList
  },
  data() {
    return {
      left: {
        show: false,
        name: this.$t('Track.resourcesList')
      },
      middle: {
        show: false,
        name: ''
      },
      right: {
        show: true,
        crumb: `${this.$t('MML.cfgManagement')}/${this.$t('NSMF.cfgExport')}`
      }
    };
  }
};
</script>
